import { useLocalization } from 'localization';
import { boolean, object, string } from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const updateUserSchema = () => {
  const { t } = useLocalization();

  return object().shape({
    firstName: string().required(),
    lastName: string().required(),
    email: string().email().required(),
    phoneNumber: string()
      .required(t('validation.mixed.required'))
      .test('phonePossible', t('validation.mixed.default'), val => {
        if (!val) return true;
        const p = parsePhoneNumberFromString(val);
        return !!p && p.isPossible() && p.isValid();
      }),
    visiblePrices: boolean().required(),
  });
};
